import { ROLES_PROVEEDOR } from '@plataforma/permisos';
import { Usuarios } from '../Usuarios';

/**
 * Equipo del proveedor (arquitectura 2.15, sección 13): el dueño del proveedor (su administrador)
 * invita operadores, que trabajan convocatorias, ofertas y trabajos sin tocar el perfil, los datos
 * bancarios ni los cobros.
 */
export function EquipoProveedor() {
  return (
    <Usuarios
      roles={ROLES_PROVEEDOR}
      rolInicial="operador"
      titulo="Mi equipo"
      subtitulo="Quién entra al Portal de Proveedores por tu negocio y qué puede hacer"
      miga={[['/portal', 'Portal de Proveedores']]}
    />
  );
}
